<template>
  <div class="client-select">
    <div class="client-select__title-wrapper"
         :class="{'client-select_disabled': !isManyClients}">
      <div class="client-select__title">Project</div>
      <div class="client-select__client-name-wrapper"
           @click="toggleOpenState()">
<!--        <div class="client-select__client-name"-->
<!--             :class="{'client-select__client-name_opened': isOpened}">-->
        <div class="client-select__client-name">
          {{currentClientName}}
        </div>
        <span class="client-select__arrow" v-if="isManyClients"></span>
      </div>
    </div>

    <div class="client-select__overlay"
         v-show="isOpened" @click.stop="toggleOpenState()"></div>
<!--  to clear selection after close dropdown replace v-show on v-if -->
    <div class="client-select__dropdown-wrapper" v-show="isOpened">
<!--      <div class="client-select__dropdown-title">Select Project</div>-->
      <base-multi-select-filter-dropdown
        class="client-select__dropdown"
        ref="select"
        :hide-header="true"
        :options="clientOptions"
        :is-smart-input="true"
        v-model="isSelected"
        :single-select="true"
        :predefinedFilter="previousSelectedClient"
        @selectionChanged="apply()"
        @apply="onClientSelected"/>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import TheNavbar from './TheNavbar'

/**
 * component is used in {@link TheNavbar} as list of all available clients
 */
export default {
  name: 'BaseClientList',
  computed: {
    previousSelectedClient () {
      return [this.clientId]
    },
    clientOptions () {
      return this.clients ? this.clients.map(item => ({ value: item._id, label: item.name })) : []
    },
    currentClientName () {
      return this.selectedClient ? this.selectedClient.name : ''
    },
    isManyClients () {
      return this.clients && this.clients.length > 1
    }
  },
  data () {
    return {
      isSelected: false,
      isOpened: false
    }
  },
  methods: {
    apply () {
      this.$refs['select'].apply()
      this.isOpened = false
    },
    close () {
      this.toggleOpenState()
    },
    toggleOpenState () {
      this.isOpened = !this.isOpened
    },
    onClientSelected (data) {
      const clientId = data.length > 0 ? data[0] : null
      if (!clientId || clientId === this.clientId) {
        return
      }
      this.setNewClient(clientId, true, true)
    }
  }
}
</script>

<style scoped lang="scss">
  .client-select {
    position: relative;
    margin-left: -10px;

    &__button {
      border: none;
      outline: none;
      cursor: pointer;
      font-size: 10px;
    }

    &_disabled {
      pointer-events: none;
    }

    &__title-wrapper {
      display: flex;
      flex-direction: column;
      padding: 10px 30px;
      cursor: pointer;
      border-bottom: 1px solid $rfx-light-steel;
    }

    &__overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9998;
      padding: 0;
      background: transparent;
    }

    &__title {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      padding: 10px 18px 0 20px;
      font-size: 14px;
      color: #011627;
      opacity: 0.4;
      font-weight: bold;
    }

    &__button-footer {
      padding: 7px 10px;
      border-radius: 4px;

      &_apply {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
        margin-right: 10px;
      }
    }

    &__client-name {
      padding: 0 20px 5px 18px;
      height: 30px;
      width: 100%;
      line-height: 30px;
      color: $rfx-bright-blue;
      font-size: 16px;
      font-weight: 500;
      margin-right: 5px;
      @include ellipsis;
      // &_opened {
      //  border-top: 1px solid $rfx-bright-blue;
      // }

      &-wrapper {
        display: flex;
      }
    }

    &__dropdown-wrapper {
      background: white;
      margin: 0px 30px 0;
      position: absolute;
      top: 76px;
      z-index: 9999;
      border-radius: 0 0 8px 8px;
    }

    &__dropdown {
      width: 210px;
    }

    &__dropdown-title {
      @extend .client-select__title;
    }

    &__footer {
      display: flex;
      margin: 10px;
      justify-content: flex-end;
    }

    &__arrow {
      flex: 0 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 26px;

      &::after {
        content: '';
        display: block;
        width: 7px;
        height: 7px;
        box-sizing: border-box;
        border-right: 2px solid $rfx-bright-blue;
        border-bottom: 2px solid $rfx-bright-blue;
        transform: rotate(45deg);
        transform-origin: center;
      }
    }
  }
</style>
